export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/activation/confirm": [3],
		"/animales": [4],
		"/animales/[slug]": [5],
		"/avisos": [6],
		"/colaboradores/[id]": [7],
		"/eliminar-cuenta": [8],
		"/establecimientos": [10],
		"/establecimientos/nuevo": [11],
		"/establecimiento": [9],
		"/importar": [12],
		"/inicio": [13],
		"/inicio/cab": [14],
		"/inicio/vet": [15],
		"/login": [16],
		"/lotes": [17],
		"/lotes/[slug]": [18],
		"/manual": [19],
		"/movimientos": [20],
		"/movimientos/detalle": [22],
		"/movimientos/lista": [23],
		"/movimientos/transferencias": [24],
		"/movimientos/[slug]": [21],
		"/nacimientos": [25],
		"/nacimientos/reporte": [27],
		"/nacimientos/[slug]": [26],
		"/notas": [28],
		"/notas/[slug]": [29],
		"/notfind": [30],
		"/oauth2/callback": [31],
		"/observaciones": [32],
		"/observaciones/[slug]": [33],
		"/opciones": [34],
		"/pagos/exito": [35],
		"/pagos/fail": [36],
		"/pagos/pending": [37],
		"/pesajes": [38],
		"/pesajes/detallemovimiento": [39],
		"/pesajes/historial": [40],
		"/pesajes/historial/[slug]": [41],
		"/pesajes/lista": [42],
		"/planes": [43],
		"/privacidad": [44],
		"/recover": [45],
		"/recover/token": [46],
		"/reportes": [47],
		"/reset-password": [48],
		"/rodeos": [49],
		"/rodeos/[slug]": [50],
		"/rol": [51],
		"/servicios": [52],
		"/servicios/movimiento": [54],
		"/servicios/movimiento/detallemovimento": [55],
		"/servicios/[slug]": [53],
		"/soporte": [56],
		"/tactos/cab": [57],
		"/tactos/cab/movimiento": [59],
		"/tactos/cab/movimiento/detallemovimiento": [60],
		"/tactos/cab/[slug]": [58],
		"/tactos/vet": [61],
		"/tareas": [62],
		"/tratamientos": [63],
		"/tratamientos/eventos/[id]": [64],
		"/tratamientos/movimiento": [65],
		"/tratamientos/movimiento/detallemovimiento": [66],
		"/tratamientos/tipos": [67],
		"/user/activate": [68],
		"/user/config": [69],
		"/user/new": [70],
		"/user/plan": [71],
		"/user/telefono": [72],
		"/user/verify-email": [73]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';